<template>
  <div class="Quiz">
    <div class="position">
      <div v-if="getWidth >= 1024" class="icon_arrow">
        <div class="arrow_left" @click="onPrev">
          <img
            style="width: 40%; height: 40%"
            src="@/assets/images/CH2/left-arrow.png"
            alt=""
          />
        </div>
      </div>
      <div class="card">
        <div class="container_TS01">
          <div class="block">
            <div
              style="width: 100%; height: 100%; display: grid"
              class="font_setting"
            >
              <div>
                <div class="containerQuestionText">
                  <p :class="checkLangClass()">
                    {{ checkLanguage(content.title) }}
                  </p>
                </div>
                <div
                  class="descrip_text"
                  v-if="content.item.data.split('//').length > 0"
                >
                  <p
                    class="instruction_text fontChinese"
                    v-for="(value, key) in instruction_text"
                    :key="key"
                  >
                    <span :id="key" ref="instruction"> {{ value }} </span>
                  </p>
                </div>
                <div style="grid-row: 3 / 7; margin-top: 3rem" v-else>
                  <p class="instruction_text fontChinese">
                    {{ content.item.data }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <CRow>
            <CCol>
              <div class="flex_between">
                <div
                  class="button_setting"
                  v-for="(item, index) in choise"
                  :key="index"
                  style="margin-top: 3%"
                >
                  <CheckBox
                    :text="choise[index]"
                    :index="index"
                    :isCheck="isCheckData"
                    @returnIndex="getReturnData"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="icon_arrow" v-if="getWidth >= 1024">
        <div class="arrow_right" @click="onSubmit">
          <img
            style="width: 40%; height: 40%"
            src="@/assets/images/CH2/right-arrow.png"
            alt=""
          />
        </div>
      </div>
      <div v-else class="menu_btn">
        <div class="btn_prev" @click="onPrev">
          <div class="btn_left">
            <div class="font_prev">
              <b>PREVIOUS</b>
            </div>
          </div>
        </div>
        <div class="btn_next">
          <div class="btn_right" @click="onSubmit">
            <div class="font_next">
              <b>NEXT</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioList from "@/components/elements/audio/AudioList";
import CheckBox from "@/components/elements/Checkbox/Checkbox";
import LoadingMDL from "@/components/loading/LoadingMDL";
import "../../../assets/scss/chinessStyle2.scss";

export default {
  components: { AudioList, CheckBox, LoadingMDL },
  name: "QZ02",
  props: {
    content: Object,
    lang: String,
  },
  data() {
    return {
      choise: [],
      soundPath: "",
      soundObject: {},
      isPlay: false,
      play: false,
      isCheckData: null,
      currentRoute: "",
      isLoadCompleted: false,
      instruction_text: "",
      ans: null,
      choise: [],
      choise_select: "",
      index_underscore: null,
      getWidth: window.innerWidth.toString(),
      state: 0,
      index_change: null,
      index_char: null,
    };
  },
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese question_text";
      } else {
        return "question_text";
      }
    },
    getReturnData: function (val) {
      this.isCheckData = val;
      this.state = 0;
      let newWord = new Array();

      this.$refs.instruction.forEach((element, index) => {
        if (element.innerHTML.includes("_") && this.choise_select == "") {
          newWord = element.innerText.split(" ");
          newWord.forEach((element, index) => {
            if (element.includes("_")) {
              this.index_char = index;
              newWord[index] =
                "<span style='color: #1d5bd7'>" +
                this.choise[val]
                  .replace(/^[A-B]+./, "")
                  .slice(0, -1)
                  .split(" ")
                  .join("") +
                "</span>";
              this.choise_select = this.choise[val]
                .replace(/^[A-B]+./, "")
                .slice(0, -1)
                .split(" ")
                .join("");
            }
          });
          this.$refs.instruction[index].innerHTML = newWord.join(" ");
          this.index_change = index;
          this.state = 1;
        } else if (
          element.innerText.includes(this.choise_select.split(" ").join("")) &&
          this.choise_select != "" &&
          this.state != 1
        ) {
          newWord = this.$refs.instruction[this.index_change].innerText.split(
            " "
          );
          newWord.forEach((element, index) => {
            if (element.includes(this.choise_select.split(" ").join(""))) {
              newWord[this.index_char] =
                "<span style='color: #1d5bd7'>" +
                this.choise[val]
                  .replace(/^[A-B]+./, "")
                  .slice(0, -1)
                  .split(" ")
                  .join("") +
                "</span>";
              this.choise_select = this.choise[val]
                .replace(/^[A-B]+./, "")
                .slice(0, -1)
                .split(" ")
                .join("");
            }
          });
          this.$refs.instruction[this.index_change].innerHTML = newWord.join(
            " "
          );
          this.state = 1;
        }
      });
      this.ans = this.choise[val];
    },
    getDifference: function (a, b) {
      var i = 0;
      var j = 0;
      var result = "";

      while (j < b.length) {
        if (a[i] != b[j] || i == a.length) result += b[j];
        else i++;
        j++;
      }
      return result;
    },
    hasWhiteSpace: function (s) {
      return s.indexOf(" ") >= 0;
    },
    onSubmit: function () {
      this.$emit("nextRoute", this.ans);
    },
    onPrev: function () {
      this.$emit("prevRoute", false);
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang.toUpperCase()) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log("change language is error 1!!");
        }
      } else {
        console.log("change language is error 2!!");
      }
    },
  },
  computed: {},
  watch: {},
  created() {
    this.instruction_text = this.content.item.data.split("//");
    let storeChoice = new Array();
    for (let i = 0; i < this.content.choices.length; i++) {
      if (this.content.choices[i].question != null) {
        storeChoice.push(this.content.choices[i].question);
      }
    }
    this.choise = storeChoice;
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
* {
  user-select: none;
}
.font_prev {
  color: #1d5bd7;
  font-size: 16px;
}
.display_quiz {
  display: flex;
  flex-direction: row;
}
.font_next {
  color: white;
  font-size: 16px;
}
.btn_prev {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}
.btn_next {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}
.btn_left {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_right {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #1d5bd7;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}
.menu_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.icon_arrow {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2%;
  margin-right: 2%;
}

.arrow_left,
.arrow_right {
  width: 60px;
  height: 60px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question_text {
  font-size: 22px;
  text-align: left;
  width: auto;
  height: auto;
}

.instruction_text {
  font-size: 24px;
  text-align: left;
  width: auto;
  height: auto;
  margin-left: 26px;
}

.card {
  background-color: white;
  width: 800px;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 30px; /* 5px rounded corners */
  padding-top: 50px;
}
.block {
  height: auto;
  margin: 0;
  border-radius: 7px;
}

.font_setting {
  height: auto;
  width: 100%;
  padding: 0px 20px;
  display: flex;
  border-radius: 10px;
  background-color: #e6efff;
}

.Quiz {
  padding-bottom: 5%;
}
.container_TS01 {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-bottom: 10.5%;
}

.detail_question {
  height: auto;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex_between {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 5%;
  margin-left: -3%;
  margin-right: -2.5%;
}
.button_setting {
  width: 45%;
  height: 60px;
  color: black;
  margin-top: 10px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px !important;
}
.audio_card {
  margin: 4rem 2rem;
}
.containerQuestionText {
  grid-row: 1 / 3;
  margin: 2rem 2rem;
}
@media only screen and (min-width: 280px) and (max-width: 415px) {
  .Quiz {
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .display_quiz {
    flex-direction: column;
  }
  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }
  .block {
    height: auto;
    margin-top: -10px;
  }
  .audio_card {
    height: 12.5rem;
    margin: 1.5rem 2rem;
  }
  .descrip_text {
    grid-row: 3 / 7;
    margin-bottom: 15px;
  }
  .instruction_text {
    font-size: 16px;
    text-align: left;
    width: auto;
    height: auto;
    margin: 0;
    margin-left: 18px;
  }
  .flex_between {
    margin-left: 0;
    margin-right: 0;
  }
  .descrip_text {
    grid-row: 3 / 7;
    margin-bottom: 15px;
  }
  .button_setting {
    width: 100% !important;
    height: 60px !important;
  }
  .card {
    width: 300px;
    border-radius: 20px;
    padding-top: 30px;
    margin: 0;
    // height: auto !important;
  }

  .detail_question {
    height: 90%;
  }
  .containerQuestionText {
    grid-row: 1 / 3;
    margin: 2rem 1rem;
  }
  .question_text {
    width: 100%;
    height: auto;
    font-size: 16px;
    font-weight: bold;
  }

  .arrow_left {
    margin-left: 10px;
  }

  .arrow_right {
    margin-right: 10px;
  }
  .checkbox {
    width: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 769px) {
  .card {
    width: 700px;
    margin-bottom: 0;
  }

  .Quiz {
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }
}

/* Add rounded corners to the top left and the top right corner of the image */
</style>
